import React from 'react'

function InterViewQ() {
  return (
    <div>InterViewQ</div>
  )
}

export default InterViewQ;